// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emoji-mart-overlay-backdrop {
  display: none;
}

.emoji-mart-overlay-panel.cdk-overlay-pane .mat-mdc-dialog-container {
  padding: 0;
  overflow: hidden;
  box-shadow: none;
}
.emoji-mart-overlay-panel.cdk-overlay-pane .mat-mdc-dialog-container .mat-mdc-dialog-surface.mdc-dialog__surface {
  padding: 0;
}
.emoji-mart-overlay-panel.cdk-overlay-pane .mat-mdc-dialog-container .mat-mdc-dialog-surface.mdc-dialog__surface .mat-mdc-dialog-content.mdc-dialog__content {
  padding: 0 !important;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-emoji-mart-overlay/fi-emoji-mart-overlay.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAGI;EACI,UAAA;EACA,gBAAA;EACA,gBAAA;AAAR;AACQ;EACI,UAAA;AACZ;AAAY;EACI,qBAAA;EACA,SAAA;AAEhB","sourcesContent":[".emoji-mart-overlay-backdrop {\r\n    display: none;\r\n}\r\n\r\n.emoji-mart-overlay-panel.cdk-overlay-pane {\r\n    .mat-mdc-dialog-container {\r\n        padding: 0;\r\n        overflow: hidden;\r\n        box-shadow: none;\r\n        .mat-mdc-dialog-surface.mdc-dialog__surface {\r\n            padding: 0;\r\n            .mat-mdc-dialog-content.mdc-dialog__content {\r\n                padding: 0 !important;\r\n                margin: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
